export const DSDarkColors = {
  black: '#EDEDED',
  white: '#1A1A1A',
  /**
   * Полупрозрачный чёрный. Число — прозрачность, а не оттенок.
   * Одинаковый в светлой и тёмной теме: затемнение должно оставаться
   * затемнением.
   */
  blackTransparent: {
    50: '#00000080',
    70: '#000000B2',
  },
  gray: {
    50: '#1E1E1E',
    100: '#2A2A2A',
    200: '#3A3A3A',
    300: '#4C4C4C',
    400: '#5F5F5F',
    500: '#737373',
    600: '#8A8A8A',
    700: '#A2A2A2',
    800: '#C2C2C2',
    900: '#E0E0E0',
  },
  primary: {
    50: '#0F2A45',
    100: '#17345A',
    200: '#214B7B',
    300: '#2A629C',
    400: '#3483BD',
    500: '#4B9FE0',
    600: '#629FF3',
    700: '#86B9FF',
    800: '#A8D2FF',
    900: '#CCE7FF',
  },
  orange: {
    50: '#3F2E15',
    100: '#5A421B',
    200: '#7C5823',
    300: '#A27031',
    400: '#C58B3C',
    500: '#E3A94E',
    600: '#FFBD6B',
    700: '#FFC08B',
    800: '#FFD3A8',
    900: '#FFE1C0',
  },
  red: {
    50: '#401616',
    100: '#571D1D',
    200: '#732626',
    300: '#943232',
    400: '#B34545',
    500: '#D25656',
    600: '#F37A7A',
    700: '#F69393',
    800: '#FAB0B0',
    900: '#FDCBCB',
  },
  green: {
    50: '#1A3B23',
    100: '#265830',
    200: '#347C40',
    300: '#43A157',
    400: '#59C070',
    500: '#73DA8C',
    600: '#8AE8A5',
    700: '#A3F4BB',
    800: '#C0FFD2',
    900: '#DCFDE8',
  },
  purple: {
    50: '#2A1741',
    100: '#381C58',
    200: '#482673',
    300: '#5D2E94',
    400: '#7435B3',
    500: '#8A48D2',
    600: '#A05BF3',
    700: '#BA79F9',
    800: '#D4A2FF',
    900: '#E9C7FF',
  },
} as const;
